/**
 * MobileEnvironmentSwitchHelper is a utility class that helps in switching the environment
 * of a mobile application by detecting a specific tap gesture.
 * It sends a message to the React Native WebView when the user taps three times within a short period.
 * Mobile applications can use this to switch between different environments (e.g., development, staging, production).
 */

import { DeviceRecognizerHelper } from "./device-recognizer.helper";

export class MobileEnvironmentSwitchHelper {
  private tapCount = 0;
  private timer: any;

  tapCounter() {
    const isMobile = DeviceRecognizerHelper.isAndroidWebview() || DeviceRecognizerHelper.isIosWebview();

    if (isMobile) {
      this.tapCount++;

      if (this.tapCount === 3) {
        window.open("https://change-url.taxando.de", "_self");
        this.reset();
        return;
      }

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.reset();
      }, 300);
    }
  }

  private reset(): void {
    this.tapCount = 0;
    clearTimeout(this.timer);
  }
}
